var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { processResponse, processError } from '../utils';
export default class HeroFreApi {
    static verifyEmail(constAccessParams, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const verifyUrl = params.is_v4_fre
                ? 'frontend/fre/v4/confirm-email/'
                : 'frontend/fre/confirm-email/';
            try {
                const response = yield axios.post(constAccessParams.API_CLOUD_HOSTNAME + verifyUrl, params);
                return processResponse(response);
            }
            catch (error) {
                return processError(error);
            }
        });
    }
}
//# sourceMappingURL=index.js.map